export class LocaleLanguage {

  private _langCode: string;
  private _langKey: string;
  private _langNativeName: string;

  public constructor(langCode: string, langKey: string, langNativeName: string) {
    this._langCode = langCode;
    this._langKey = langKey;
    this._langNativeName = langNativeName;
  }

  /** two-letter code like "en" or "de" */
  public get langCode(): string {
    return this._langCode;
  }

  /** four-letter key like "en_US" or "de_DE" */
  public get langKey(): string {
    return this._langKey;
  }

  public get langNativeName(): string {
    return this._langNativeName;
  }
}
